<template>
    <div class="flex flex-col xl:flex-row gap-4 xl:gap-10 text-xs text-grey-90"
         v-if="footerDateValue || showOrgInfoName">

        <div v-if="footerDateValue" class="flex items-center gap-1">
            <span class="shrink-0">{{ footerDateLabel }}:</span>
            {{ footerDateValue }}
        </div>

        <!-- Owner -->
        <div class="flex items-center gap-1" v-if="showOrgInfoName">
            <span class="shrink-0">{{ t('solutionCard.owner') }}:</span>

            <SolutionOrgIcon :org-info-logo="OrgInfo?.logo" class="h-4 w-4" />

            <a v-if="companyHref" :href="companyHref" target="blank" class="hover:underline">
                <span class="max-w-[200px] block truncate" :title="showOrgInfoName" v-html="showOrgInfoName" />
            </a>
            <span v-else class="max-w-[200px] block truncate" :title="showOrgInfoName" v-html="showOrgInfoName" />
            <OrgPopover v-if="showOrgInfoCounts" :counts="showOrgInfoCounts" :orgs="profile.ORG_INFO"></OrgPopover>
        </div>
    </div>
</template>

<script setup lang="ts">
import SolutionOrgIcon from './SolutionOrgIcon.vue'
import OrgPopover from './OrgPopover.vue'
import { computed } from 'vue';
import _ from 'lodash';
import { cn, tw, en, jp } from './locales';
import { useI18n } from 'vue-i18n';
import { generateCompanyHref } from '@eureka/utils/company';
import { SOLUTION_TYPE } from '@eureka/solution-card/src/types';
import type { ISolution } from '@eureka/solution-card/src/types';

const { t } = useI18n({
    messages: {
        cn, en, jp, tw,
    },
})

const props = defineProps<{
    profile: ISolution
    footerField?: string
}>()

const currentDateField = computed(() => {
    if (props.footerField) {
        return props.footerField
    }
    return props.profile.SOLUTION_TYPE === SOLUTION_TYPE.PATENT ? 'APD' : 'PBD'
})

const footerDateLabel = computed(() => {
    return t(`solutionCard.${props.profile.SOLUTION_TYPE}.${currentDateField.value}`)
})

const footerDateValue = computed(() => {
    return _.get(props.profile, currentDateField.value) || _.get(props.profile, 'publication_time')
})

const companyHref = computed(() => {
    const orgId = _.get(props.profile, 'ORG_INFO[0].id', '')
    return generateCompanyHref(orgId)
})

const showOrgInfoName = computed(() => {
    return _.get(props.profile, 'ORG_INFO[0].display_name', '')
})

const OrgInfo = computed(() => {
    return _.get(props.profile, 'ORG_INFO[0]')
})

const showOrgInfoCounts = computed(() => {
    return _.get(props.profile, 'ORG_INFO', []).length ? _.get(props.profile, 'ORG_INFO', []).length - 1 : 0
})

</script>
<style lang="scss">
.org_logo {
    width: 16px !important;
    height: 16px !important;
    border-radius: 4px;
    border: 1px solid var(--border-light);
    margin-right: 4px;
    vertical-align: text-bottom !important;
    object-fit: contain;
}
</style>
